import {RemoveButton, loginContainer} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';

import styles from './ArrayScreenWrapperRemoveButton.less';

const I18N = defineMessages({
  REMOVE_BUTTON: {
    id: 'autoLayout.arrayWrapper.button.remove',
    defaultMessage: 'Remove item',
    description: 'text for auto layout array container remove button',
  },
});

const ArrayScreenWrapperRemoveButton = ({item, isDisabled, onRemove}) => (
  <RemoveButton
    removeCallback={onRemove}
    className={classNames(styles.dlArrayItemRemoveButton, 'fa-2x', 'float-end')}
    item={item}
    disabled={isDisabled}
    titleText={I18N.REMOVE_BUTTON.id}
  />
);

ArrayScreenWrapperRemoveButton.displayName = 'ArrayScreenWrapperRemoveButton';

ArrayScreenWrapperRemoveButton.propTypes = {
  isDisabled: PropTypes.bool,
  item: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onRemove: PropTypes.func.isRequired,
};

ArrayScreenWrapperRemoveButton.defaultProps = {
  isDisabled: false,
};

export default ArrayScreenWrapperRemoveButton;
